<script setup lang="ts">
import stars from '../assets/stars.png'

defineProps<{
    modelValue: string
}>()

const emit = defineEmits<{
    'update:modelValue': [value: string]
}>()
</script>

<template>
    <div
        class="flex items-center rounded-2xl border border-zinc-300 bg-zinc-100 text-neutral-800 dark:border-zinc-800 dark:bg-zinc-900 dark:text-neutral-300"
    >
        <div
            class="flex flex-col items-center gap-1 rounded-l-2xl bg-linear-to-l to-sky-100/10 px-4 py-3 font-medium select-none"
        >
            <img
                :src="stars"
                class="select-none opacity-50 dark:invert-100"
                :draggable="false"
                width="24"
            />

            GR
        </div>

        <input
            :value="modelValue"
            type="text"
            maxlength="2"
            placeholder="π.χ ΙΤ, ΜΙ, ΚΥ"
            class="h-full w-48 px-2 font-medium text-zinc-600 outline-none placeholder:text-neutral-400 dark:text-zinc-200"
            @input="
                emit(
                    'update:modelValue',
                    ($event.target as HTMLInputElement).value,
                )
            "
        />
    </div>
</template>
